import { isEmpty } from 'lodash';
import { memo, useContext } from 'react';
import { useNavigate, useParams } from 'react-router';
import useMarketStudies from '../App/hooks/useMarketStudies';

import ActionNotification from '../components/Assets/ActionNotification';
import Footer from '../components/Assets/Footer';
import IndividualCircularLoader from '../components/Loader/IndividualCircularLoader';
import Header from '../components/MarketStudyResult/Header';
import MultiGraphBloc from '../components/MarketStudyResult/MultiGraphBloc';
import ResultSummary from '../components/MarketStudyResult/ResultSummary';

import { marketStudiesActions } from '../store/marketStudies/actions';

import CreateMarketStudyResultCtx from '../App/contexts/marketStudyContext';
import { useAppDispatch } from '../App/redux/store';
import GoodContainer from '../components/MarketStudyResult/GoodContainer';
import './styles/marketStudiesResultPage.scss';

export enum GoodTypeEnum {
  TERRAIN,
  CONSTRUCTION,
  NONE,
}
const [ctx, MarketStydyResultProvider] = CreateMarketStudyResultCtx();

export const MarketStudyResultContext = ctx;

function MarketStudiesResultPage() {
  const { id } = useParams<{ id: string }>();

  const { setSqmTypo, setStockTypo } = useContext(MarketStudyResultContext);

  const { marketStudyResult, selectedMarketStudy } = useMarketStudies(
    id ?? null,
    id as string,
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleCancel = () => {
    dispatch(marketStudiesActions.resetActiveMarketStudy.success());
    navigate('/etudes-de-marche');
  };

  const handleSubmit = () => {
    dispatch(
      marketStudiesActions.updateMarketStudy.request({
        body: selectedMarketStudy,
        isCommentUpdate: true,
      }),
    );
    handleCancel();
  };

  return (
    <>
      <main className="market-studies-result-wrapper">
        <ActionNotification />

        <Header handleSubmit={handleSubmit} handleCancel={handleCancel} />

        <div>
          <>
            <ResultSummary result={marketStudyResult} />

            {!marketStudyResult ? (
              <IndividualCircularLoader size={200} />
            ) : !isEmpty(marketStudyResult) ? (
              <section className="market-studies-result-prices">
                <GoodContainer
                  type={
                    selectedMarketStudy?.propertyTypology
                      ? selectedMarketStudy?.propertyTypology.name === 'Terrain'
                        ? GoodTypeEnum.TERRAIN
                        : GoodTypeEnum.CONSTRUCTION
                      : GoodTypeEnum.NONE
                  }
                />
              </section>
            ) : (
              <p className="no-result">Aucun Resultat pour cette étude de marché</p>
            )}
            <MultiGraphBloc type="prices" id={id} handleGraph={setSqmTypo}>
              Évolution des prix m² par typologies sur 1 an
            </MultiGraphBloc>
            <MultiGraphBloc type="stocks" id={id} handleGraph={setStockTypo}>
              Évolution des stocks par typologies sur 1 an
            </MultiGraphBloc>
          </>
        </div>
      </main>

      <Footer
        marketStudies
        handlePrint={() => {}}
        handleClick={handleSubmit}
        handleEdit={handleSubmit}
      />
    </>
  );
}

function ContextProviderPage() {
  return (
    <MarketStydyResultProvider>
      <MarketStudiesResultPage />
    </MarketStydyResultProvider>
  );
}
export default memo(ContextProviderPage);
